import { render, staticRenderFns } from "./oneStopProcessingProve.vue?vue&type=template&id=b62e05b8&scoped=true&"
import script from "./oneStopProcessingProve.vue?vue&type=script&lang=js&"
export * from "./oneStopProcessingProve.vue?vue&type=script&lang=js&"
import style0 from "./oneStopProcessingProve.vue?vue&type=style&index=0&id=b62e05b8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b62e05b8",
  null
  
)

export default component.exports